import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { CTATextContent } from '../CTATextContent';
import { SubscriptionFormWithDisclaimer } from '../../../forms/SubscriptionForm';
import { getBgColor, getCtaBtnColor } from '../utils';
import { Button, BrandButton, DarkBackgroundButton, Colors, } from '../../../../index';
const Styles = labelStyles('CTACentered', {
    root: (backgroundColor) => css `
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 30px;
    background-color: ${Colors[backgroundColor]};

    @media screen and (min-width: 768px) {
      padding: 40px;
    }

    @media screen and (min-width: 1230px) {
      padding: 70px 200px;
    }
  `,
    mediaContent: (maxWidth) => css `
    max-width: ${maxWidth}px;
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `,
});
const getSubscriptionFormButton = (bgColor, ctaBtnColor) => {
    const btnColor = getCtaBtnColor(bgColor, ctaBtnColor);
    const btnProps = {
        children: 'Submit',
        type: 'submit',
    };
    if (btnColor === 'primary-dark')
        return isolateComponent(DarkBackgroundButton, Object.assign({}, btnProps));
    else if (btnColor === 'brand')
        return isolateComponent(BrandButton, Object.assign({}, btnProps));
    else {
        return isolateComponent(Button, Object.assign({}, btnProps, { color: btnColor, size: "small" }));
    }
};
export const CTACentered = ({ backgroundColor = 'neutral100', ctaHref, ctaBtnColor, ctaText, description, heading, maxWidth = 570, onCtaClick, onCtaKeyDown, subHeading, isSubscriptionForm, subscriptionPlaceholder, onSubscriptionFormSubmit, ctaTarget, }) => {
    const bgColor = getBgColor(backgroundColor);
    const isZapierOrange = bgColor === 'zapier';
    if (isZapierOrange && isSubscriptionForm) {
        console.error('Do not use the subscription form with the zapier background. The disclaimer text accessibility ' +
            'is poor on the zapier background.');
    }
    return (isolateComponent("div", { css: Styles.root(bgColor) },
        isolateComponent("div", { css: Styles.mediaContent(maxWidth) },
            isolateComponent(CTATextContent, { heading: heading, subHeading: subHeading, description: description, ctaText: !isSubscriptionForm ? ctaText : undefined, ctaHref: !isSubscriptionForm ? ctaHref : undefined, ctaBtnColor: ctaBtnColor, onCtaClick: !isSubscriptionForm ? onCtaClick : undefined, onCtaKeyDown: onCtaKeyDown, bgColor: bgColor, alignment: "center", ctaTarget: ctaTarget })),
        isSubscriptionForm ? (isolateComponent(SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder || '', renderButton: () => getSubscriptionFormButton(backgroundColor, ctaBtnColor), onSubmit: onSubscriptionFormSubmit, disclaimerTextColor: bgColor === 'neutral100' ? 'primary' : 'secondary', disclaimerTextType: "paragraph3" })) : null));
};
//# sourceMappingURL=CTACentered.js.map
// @zapier/design-system@6.14.1 (10126c41d)
